import { useCallback, useSyncExternalStore } from 'react'

const getServerSnapshot = (): boolean => false

export const useMediaQuery = (query: string): boolean => {
    const subscribe = useCallback(
        (onChange: () => void) => {
            if (typeof window === 'undefined' || !window.matchMedia) return () => undefined
            const mediaQuery = window.matchMedia(query)
            mediaQuery.addEventListener('change', onChange)
            return () => mediaQuery.removeEventListener('change', onChange)
        },
        [query]
    )
    const getSnapshot = useCallback(() => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches, [query])

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
